<button
    type="button"
    [class]="'action-btn ' + btnClass"
    (click)="clickHandler($event)"
    [disabled]="disabled"
>
    <i [class]="iconClass"></i>
</button>
